import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = (props) => {

    return (
        props.loading
            ? <div className="tab-loading" >
                <Spinner
                    animation="border"
                    role="status"
                    aria-hidden="true"
                    variant="primary"
                    size="lg"
                />
                Loading...
            </div>
            : <div />
    );
};

export default Loader;